import type { VisiteDemandee } from './NouvelleVisite.js';

/**
 * LA VISITE QU'UN ANIMAL RECOIT, pure : aucun React, aucun SDK, testee par
 * `visite.test.mjs`. « Consulter maintenant » (fenetre de la fiche, sur toutes
 * ses vues) et « Planifier » (menu du Dossier de l'animal) creent la meme
 * consultation par ce seul calcul ; ils ne different que par `quand`.
 */

/** La raison dite dans la fenetre quand l'app qui montre les consultations manque. */
export const SANS_CONSULTATIONS = "L'app Consultations n'est pas installée.";

/**
 * Le document d'une consultation creee depuis la fiche d'un animal. `quand`
 * vide : maintenant, a l'etape « En consultation ». Sinon « Prevue » a l'heure
 * choisie. Le veterinaire n'est ecrit que s'il est choisi.
 */
export function consultationDeLaVisite(
  orgId: string,
  animalId: string,
  demande: VisiteDemandee,
  maintenant: Date = new Date(),
) {
  return {
    orgId,
    type: 'consultation' as const,
    assetId: animalId,
    performedAt: demande.quand ?? maintenant,
    customFields: {
      reason: demande.motif,
      stage: demande.quand === null ? 'enConsultation' : 'prevue',
      ...(demande.veterinaire === '' ? {} : { veterinarian: demande.veterinaire }),
    },
  };
}
